import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './features/layout/Layout';
import Home from './features/home/Home';
import Login from './features/login/Login';
import Register from './features/register/Register';
import Sedes from './features/sedes/Sedes';
import Disponibilidades from './features/disponibilidades/Disponibilidades';
import Servicios from './features/servicios/Servicios';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MedicoRoute from './components/auth/MedicoRoute';
import PacienteRoute from './components/auth/PacienteRoute';
import Turnos from './features/turnos/Turnos';
import Historial from './features/turnos/Historial';
import Perfil from './features/perfil/Perfil';
import Agenda from './features/agenda/Agenda';
import SolicitudesCambio from './features/solicitudesCambio/SolicitudesCambio';
import BuscarTurnos from './features/buscarTurnos/BuscarTurnos';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="perfil" element={<Perfil />} />
        <Route
          path="sedes"
          element={
            <MedicoRoute>
              <Sedes />
            </MedicoRoute>
          }
        />
        <Route
          path="disponibilidades"
          element={
            <MedicoRoute>
              <Disponibilidades />
            </MedicoRoute>
          }
        />
        <Route
          path="servicios"
          element={
            <MedicoRoute>
              <Servicios />
            </MedicoRoute>
          }
          />
        <Route
          path="buscar-turnos"
          element={
            <PacienteRoute>
              <BuscarTurnos />
            </PacienteRoute>
          }
        />
        <Route
          path="turnos"
          element={
            <PacienteRoute>
              <Turnos />
            </PacienteRoute>
          }
        />
        <Route
          path="turnos/historial"
          element={
            <PacienteRoute>
              <Historial />
            </PacienteRoute>
          }
        />
        <Route
          path="agenda"
          element={<Agenda />}
        />
        <Route path="solicitudes-cambio" element={<SolicitudesCambio />} />
      </Route>
    </Routes>
  );
}

export default App;
